import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';

import * as Styled from 'components/ToolkitV2/CardV2/enhancements/WithHeader/WithHeader.styled';

import type { WithHeaderProps } from 'components/ToolkitV2/CardV2/enhancements/WithHeader/WithHeader.typed';

function WithHeader(props: WithHeaderProps) {
  const { children, header, isGrid, includesHighlight, rightSlot } = props;

  const showBorder = Boolean(
    header?.title && header.logo && !isGrid && !includesHighlight,
  );

  return (
    <>
      {header?.title && header.logo && (
        <Styled.Header isGrid={isGrid} showBorder={showBorder}>
          <InfoTitle
            title={header.title}
            listItems={[header.subTitle]}
            illustration={header.logo}
            variant="SMALL"
            shouldTruncate
            smallTruncationWidth={192}
            largeTruncationWidth={360}
          />
          {rightSlot}
        </Styled.Header>
      )}
      {children}
    </>
  );
}

export { WithHeader };
